import {
	reSpecificWeightConstants
}from "./constants"
import actions from '../../../actions'

const initialState = {
	error     : null,
	isSending : false,
	kinds     : null,
	list      : null,
	paged     : {}
}

export default function (state = initialState, action){
	switch (action.type){
		case (reSpecificWeightConstants.GetKinds.REQUEST):
		case (reSpecificWeightConstants.GetList.REQUEST):
		case (reSpecificWeightConstants.GetPaged.REQUEST):
		case (reSpecificWeightConstants.Upload.REQUEST):
			return {
				...state,
				isSending : true,
				changed   : null
			}

		case (reSpecificWeightConstants.GetPaged.SUCCESS):
			return {
				...state,
				isSending : false,
				paged    	: action.payload.result
			}

		case (reSpecificWeightConstants.GetKinds.SUCCESS):
			return {
				...state,
				isSending	: false,
				kinds    	: action.payload.result
			}
		case (reSpecificWeightConstants.GetList.SUCCESS):
			return {
				...state,
				isSending	: false,
				list     	: action.payload.result
			}

		case reSpecificWeightConstants.Upload.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.download : null
			}

		case (reSpecificWeightConstants.GetKinds.FAILURE):
		case (reSpecificWeightConstants.GetList.FAILURE):
		case (reSpecificWeightConstants.GetPaged.FAILURE):
		case (reSpecificWeightConstants.Upload.FAILURE):
			return {
				...state,
				isSending	: false,
				error    	: action.payload
			}

		case (reSpecificWeightConstants.CLEAR):
			return {
				error     : null,
				isSending : false,
				kinds     : null,
				list      : null,
				paged     : {}
			}

		default:
			return state
	}
}